//Action Types
export var BOOKINGS_RESET_ACTION_TYPE = 'bookings/reset';
export var BOOKINGS_FETCH_START_ACTION_TYPE = 'bookings/fetch_start';
export var BOOKINGS_FETCH_SUCCESS_ACTION_TYPE = 'bookings/fetch_success';
export var BOOKINGS_FETCH_PENDINGS_START_ACTION_TYPE = 'bookings/fetch_pendings_start';
export var BOOKINGS_FETCH_PENDINGS_SUCCESS_ACTION_TYPE = 'bookings/fetch_pendings_success';
export var BOOKINGS_FETCH_WITH_STAFF_ISSUES_START_ACTION_TYPE = 'bookings/fetch_with_staff_issues_start';
export var BOOKINGS_FETCH_WITH_STAFF_ISSUES_SUCCESS_ACTION_TYPE = 'booking/fetch_with_staff_issues_success';
export var BOOKINGS_GET_START_ACTION_TYPE = 'bookings/get_start';
export var BOOKINGS_GET_SUCCESS_ACTION_TYPE = 'bookings/get_success';
export var BOOKINGS_GET_INVOICE_BOOKING_START_ACTION_TYPE = 'bookings/get_invoice_booking_start';
export var BOOKINGS_GET_INVOICE_BOOKING_SUCCESS_ACTION_TYPE = 'bookings/get_invoice_booking_success';
export var BOOKINGS_CONFIRM_START_ACTION_TYPE = 'bookings/confirm_start';
export var BOOKINGS_CONFIRM_SUCCESS_ACTION_TYPE = 'bookings/confirm_success';
export var BOOKINGS_CONFIRM_APPOINTMENT_START_ACTION_TYPE = 'bookings/confirm_appointment_start';
export var BOOKINGS_CONFIRM_APPOINTMENT_SUCCESS_ACTION_TYPE = 'bookings/confirm_appointment_success';
export var BOOKINGS_CANCEL_START_ACTION_TYPE = 'bookings/cancel_start';
export var BOOKINGS_CANCEL_SUCCESS_ACTION_TYPE = 'bookings/cancel_success';
export var BOOKINGS_DELETE_START_ACTION_TYPE = 'bookings/delete_start';
export var BOOKINGS_DELETE_SUCCESS_ACTION_TYPE = 'bookings/delete_success';
export var BOOKINGS_ASSIGN_STAFF_ACTION_TYPE = 'bookings/assign_staff';
export var BOOKINGS_ERROR_ACTION_TYPE = 'bookings/error';
export var BOOKINGS_UPDATE_LOCAL_ACTION_TYPE = 'bookings/update_local';
export var BOOKINGS_REMOVE_LOCAL_ACTION_TYPE = 'bookings/remove_local';
export var BOOKINGS_REMOVE_SEVERAL_LOCAL_ACTION_TYPE = 'bookings/remove_several_local';
export var BOOKINGS_CANCEL_SEVERAL_LOCAL_ACTION_TYPE = 'bookings/cancel_several_local';
export var BOOKINGS_FETCH_CLIENT_START_ACTION_TYPE = 'bookings/fetch_client_start';
export var BOOKINGS_FETCH_CLIENT_SUCCESS_ACTION_TYPE = 'bookings/fetch_client_success';
export var BOOKINGS_FETCH_CLIENT_PENDINGS_START_ACTION_TYPE = 'bookings/fetch_client_pendings_start';
export var BOOKINGS_FETCH_CLIENT_PENDINGS_SUCCESS_ACTION_TYPE = 'bookings/fetch_client_pendings_success';
export var BOOKINGS_FETCH_CLIENT_WITH_STAFF_ISSUES_START_ACTION_TYPE = 'bookings/fetch_client_with_staff_issues_start';
export var BOOKINGS_FETCH_CLIENT_WITH_STAFF_ISSUES_SUCCESS_ACTION_TYPE = 'bookings/fetch_client_with_staff_issues_success';
export var BOOKINGS_LOCK_START_ACTION_TYPE = 'bookings/lock_start';
export var BOOKINGS_LOCK_END_ACTION_TYPE = 'bookings/lock_end';
export var BOOKINGS_UNLOCK_START_ACTION_TYPE = 'bookings/unlock_start';
export var BOOKINGS_UNLOCK_SUCCESS_ACTION_TYPE = 'bookings/unlock_success';
export var BOOKINGS_UNLOCK_UNAUTHORIZED_ACTION_TYPE = 'bookings/unlock_aunauthorized';
